import {
  TeamMembersContainerRow,
  TeamMembersHeader,
  TeamMembersImageRow,
  ImageContainer,
} from './styled';
import { OneColumnExpanded } from '../../styled';
import { Column } from '@simplywallst/ui-core';
import LinkedInIcon from '@assets/images/logo/linkedin.svg';
import { useContentfulImage } from '@/hooks/useContentfulImage';
import DeferRenderUntilIntersecting from '@/components/DeferRenderUntilIntersecting';
import { Helmet } from 'react-helmet-async';

interface TeamMemberImage {
  title?: string;
  description?: string;
  url?: string;
}

interface TeamMembersProps {
  title: string;
  gallery: TeamMemberImage[];
  linkedIn: string[];
}

interface Props {
  image: TeamMemberImage;
  linkedIn: string;
}

const TeamMember = ({ image, linkedIn }: Props) => {
  const profileImage = useContentfulImage({
    url: image && image.url,
    format: 'avif',
  });
  const profileImageFallback = useContentfulImage({
    url: image && image.url,
    format: 'jpg',
  });

  return (
    <>
      <Helmet>
        <link rel="prefetch" href={profileImage?.src} />
        <link rel="prefetch" href={profileImageFallback?.src} />
      </Helmet>
      <ImageContainer>
        {profileImage && profileImageFallback && (
          <DeferRenderUntilIntersecting>
            {() => (
              <picture>
                <source srcSet={profileImage.src} type="image/avif" />
                <img src={profileImageFallback.src} alt={image.title ?? ''} />
              </picture>
            )}
          </DeferRenderUntilIntersecting>
        )}
        <strong>{image.title}</strong>
        <p>{image.description}</p>
        <a
          href={linkedIn}
          rel="noopener noreferrer"
          aria-label="LinkedIn profile"
        >
          <LinkedInIcon />
        </a>
      </ImageContainer>
    </>
  );
};

export const TeamMembers = ({ title, gallery, linkedIn }: TeamMembersProps) => {
  return (
    <TeamMembersContainerRow justifyContent="center">
      <OneColumnExpanded>
        <TeamMembersHeader>
          <h2>{title}</h2>
        </TeamMembersHeader>
        <TeamMembersImageRow justifyContent="center">
          {gallery.map((image, i) => (
            <Column key={i} col={6} colSm={4} colLg={3}>
              <TeamMember image={image} linkedIn={linkedIn[i]} />
            </Column>
          ))}
        </TeamMembersImageRow>
      </OneColumnExpanded>
    </TeamMembersContainerRow>
  );
};
